export default "__VITE_ASSET__ERQ3bwzT__"